import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { CityInterface } from "../../common/types/interfaces";

interface CityState {
  city: CityInterface | undefined;
}

const initialState: CityState = {
  city: undefined,
};

export const citySlice = createSlice({
  name: "city",
  initialState,
  reducers: {
    setCity: (state, action: PayloadAction<CityInterface | undefined>) => {
      state.city = action.payload;
    },
    clearCity: (state) => {
      state.city = undefined;
    },
  },
});

export const { setCity, clearCity } = citySlice.actions;

export const selectCity = (state: RootState) => state.city.city;

export default citySlice.reducer;
